import { handleActions } from 'redux-actions'
import { fromJS } from 'immutable'

import * as Actions from 'actions/journalists'
import * as AppActions from 'actions/app'

export const initialState = fromJS({
  journalists: {
    page: 1,
    size: 20,
    sortBy: 'profile_score',
    sortDirection: 'desc'
  },
  myContacts: {
    page: 1,
    size: 20,
    sortBy: 'profile_score',
    sortDirection: 'desc'
  }
})

export default handleActions({
  [Actions.setPagination]: (state, { payload }) => state.mergeIn(['journalists'], fromJS(payload)),
  [Actions.setMyContactsPagination]: (state, { payload }) => state.mergeIn(['myContacts'], fromJS(payload)),
  [AppActions.resetState]: () => initialState
}, initialState)
